import React, { useState, useEffect } from 'react';

export const a2hsContext = React.createContext();

let session = {};
let _platform = {};
let showNativePrompt = false;
let beforeInstallPromptEvent = null;

/* 
  browsers that we will support
    chrome
    firefox
    DuckDuckGo
    Opera
    samsung browser
    Sadari
*/

const Addtohomescreenstore = ({children}) => {

    const [installEvent, setinstallEvent] = useState(false);
    const [platform, setplatform] = useState(_platform);
    const [initialized, setinitialized] = useState(false);

    useEffect(() => {
      initialize();
      
      // after 30 seconds set initialised to true anyway
      window.setTimeout(()=>{
        setinitialized(true);
      },30000);

    }, []);

    return (
        <a2hsContext.Provider value={[platform, installEvent, initialized]}>
            {children}
        </a2hsContext.Provider>
    );

    function initialize() {
      // add event to catch the install prompt (if its available)
      if ('onbeforeinstallprompt' in window) {
        doLog('add beforeinstallprompt listener');
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      }
    
      // add event for after the app install has finished
      if ('onappinstalled' in window) {
        window.addEventListener('appinstalled', function (evt) {
          doLog('A2HS installed');
          session.added = true;
          //updateSession();
          // if (configuration.onInstall) {
          //   configuration.onInstall.call(this);
          // }
        });
    
      }
    
      checkPlatform();
    
      //let sessionString = window.localStorage.getItem(configuration.appId);
      //session = sessionString ? JSON.parse(sessionString) : DEFAULT_SESSION;
    
      // if (session && session.added) {
      //   // there is nothing to do if app was already added to home screen
      //   doLog("allready on homescreen");
      //   return;
      // }
    
      if ('serviceWorker' in navigator) {
        let manifestElement = document.querySelector('[rel=\'manifest\']');
        if (!manifestElement) {
          doLog('no manifest file');
          _platform.isCompatible = false;
        }
        setTimeout(function () {
          // we wait 1 sec until we execute this because sometimes the browser needs a little time to register the service worker
          navigator.serviceWorker.getRegistration().then(afterServiceWorkerCheck);
          //buildGuidanceURLs(configuration.customPromptPlatformDependencies);
        }, 1000);
      } else {
        afterServiceWorkerCheck({});
      }
    
    }
    
    
    function handleBeforeInstallPrompt(event) {
      console.log(event);
      showNativePrompt = true;
      event.preventDefault();
      doLog('capturing the native A2HS prompt');
      beforeInstallPromptEvent = event;
      setinstallEvent(beforeInstallPromptEvent);
      doLog(JSON.stringify(beforeInstallPromptEvent));
    }
    
    function updateSession() {
      window.localStorage.setItem("Add-To-Home-Screen", JSON.stringify(session));
    }

    function mobileAndTabletCheck(){
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };
    
    function checkPlatform() {
      // browser info and capability
      let userAgent = window.navigator.userAgent;
      console.log(window.navigator);
      doLog('checking platform - found user agent: ' + userAgent);
    
      //platform.isIDevice = (/iphone|ipod|ipad/i).test(userAgent);
      _platform.isSamsung = /Samsung/i.test(userAgent);
      _platform.isFireFox = /Firefox/i.test(userAgent);
      _platform.isOpera = /opr/i.test(userAgent);
      _platform.isEdge = /edg/i.test(userAgent);
    
      // Opera & FireFox only Trigger on Android
      if (_platform.isFireFox) {
        _platform.isFireFox = /android/i.test(userAgent);
      }
    
      if (_platform.isOpera) {
        _platform.isOpera = /android/i.test(userAgent);
      }
      
      _platform.isChromium = ('onbeforeinstallprompt' in window);
      _platform.isInWebAppiOS = (window.navigator.standalone === true);
      _platform.isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);
      _platform.isMobileSafari = _platform.isIDevice && userAgent.indexOf('Safari') > -1 && userAgent.indexOf('CriOS') < 0;
      _platform.isStandalone = _platform.isInWebAppiOS || _platform.isInWebAppChrome;
      _platform.isiPad = (_platform.isMobileSafari && userAgent.indexOf('iPad') > -1);
      _platform.isiPhone = (_platform.isMobileSafari && userAgent.indexOf('iPad') === -1);
      _platform.isMobile = mobileAndTabletCheck();
      _platform.isCompatible = (_platform.isChromium || _platform.isMobileSafari ||
      _platform.isSamsung || _platform.isFireFox || _platform.isOpera) && _platform.isMobile;
        
      _platform.name = "Chrome";

      if(_platform.isSamsung){
        _platform.name = "Samsung"
      }else if(_platform.isMobileSafari){
        _platform.name = "Safari"
      }else if(_platform.isOpera){
        _platform.name = "Opera"
      }else if(_platform.isFireFox){
        _platform.name = "Firefox"
      }else if(_platform.isDuckDuckGo){
        _platform.name = "DuckDuckGo"
      }else if(_platform.isChromium){
        _platform.name = "Chrome"
      }

      setplatform(oldPlatform => {return {..._platform}});
    }
    
    function afterServiceWorkerCheck(serviceWorker) {
      if (!serviceWorker) {
        //doLog('no service worker');
        _platform.isCompatible = false;
      }
      doLog('service worker found - increasing page views');
    
      session.pageViews += 1;
      updateSession();
    
      
      doLog('decide to show:  beforeInstallPromptEvent: ' + beforeInstallPromptEvent + ' ### showNativePrompt: ' + showNativePrompt);
      if (!beforeInstallPromptEvent) {
        doLog('autoStart - displaying call-out');
      } else if (!showNativePrompt) {
        doLog('not showing native prompt - displaying call-out');
      } else {
        doLog('did decide to show nothing');
      }
    
    }
    
    
    function doLog(logString) {    
      //alert('Add to Homescreen: ' + logString);
      console.log('Add to Homescreen: ' + logString);
    }
}


export default Addtohomescreenstore;
